<template>
	<div class="contact-banner">
		<div class="row">
			<div class="col-md-6 col-lg-8 left-side">
				<h3 class="text-light-blue">Still need help?</h3>
				<p>
					If our FAQs didn't answer your question, visit our contact page for more help or to speak with a member of our friendly customer service team.
				</p>
			</div>
			<div class="col-md-6 col-lg-4 right-side">
				<a href="/contact" class="btn continue-btn btn-lg btn-block">Contact us</a>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "ContactBanner"
}
</script>

<style scoped>

</style>